// extracted by mini-css-extract-plugin
export default {"admin":"admin_admin__EI0qn","admin__wrapper":"admin_admin__wrapper__qMb1S","admin__container":"admin_admin__container__d2OEd"};